<template>
    <van-popup
        v-model="showPopup"
        position="bottom"
        round
        safe-area-inset-bottom
        :close-on-click-overlay="true"
        @close="onClose"
    >
      <div class="popupView">
        <div class="topView">{{title}}</div>
        <div class="contentView">{{content}}</div>
        <div class="bottomView">
            <div class="bottomBtn" @click.stop="onClose">我知道了</div>
        </div>
      </div>
    </van-popup>
</template>
<script>
    export default{
        props:{
            show:{
                type:Boolean,
                default:() => {
                    return false
                }
            },
            title:{
                type:String,
                default:() => {
                    return ''
                }
            },
            content:{
                type:String,
                default:() => {
                    return ''
                }
            }
        },
        watch:{
            show: {
                handler(val) {
                    this.showPopup = val
                },
                immediate: true
            },
        },
        data(){
            return{
                showPopup:false
            }
        },
        created(){

        },
        mounted(){

        },
        methods:{
            onClose(){
                this.$emit('close')
            }
        }
    }
</script>
<style lang="less" scoped>
@import url("../style/index.css");

.popupView {
  position: relative;
  width: 100%;
  .topView{
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 36px 70px 0 70px;
    font-size: 36px;
    font-weight: 500;
    color: #3B3A38;
    line-height: 44px;
  }
  .contentView{
    padding: 61px 70px;
    font-size: 26px;
    font-weight: 500;
    color: #3B3A38;
    line-height: 34px;
    white-space: normal;
    word-break: break-all;
    min-height: 470px;
    max-height: 50vh;
    overflow-y: scroll;
  }
  .bottomView{
    position: fixed;
    background: #FFFFFF;
    bottom: env(safe-area-inset-bottom);
    bottom: constant(safe-area-inset-bottom);
    left: 0;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100px;
    .bottomBtn{
        width: 90%;
        height: 80px;
        display: flex;
        align-items: center;
        justify-content: center;
        background: #4466F5;
        border-radius: 40px;
        font-size: 28px;
        font-weight: 500;
        color: #FFFFFF;
        line-height: 40px;
    }
  }
}

</style>